import { APIGet, APIPut, APIUrl, AdminType } from "api/protocols";
import { CancelToken } from "axios";
import { IBookingEngine } from "redux/reducers/bookingEngine";


interface IGetBookingEngine {
  id?: string;
  extended?: boolean;
  facility_access_token?: string;
}

// GET Booking Engine
export async function GetBookingEngine(params: IGetBookingEngine, useGlobalLoader: boolean, token?: CancelToken) {
  return await APIGet<IBookingEngine[]>(
    APIUrl(AdminType.FacilityAdmin, "/tee-sheet/booking-engine"),
    params,
    useGlobalLoader,
    token,
  );
}

export interface IPutBookingEngine {
  id?: string;
  extended?: boolean;
  facility_access_token?: string;
  booking_category_ids?: number[];
}
// PUT Booking Engine
export async function PutBookingEngine(params: IPutBookingEngine, useGlobalLoader: boolean) {
  return await APIPut(APIUrl(AdminType.FacilityAdmin, "/tee-sheet/booking-engine"), params, useGlobalLoader);
}
